/* Dolosway sound — dice clatter rattle, UI blips, winner fanfare arpeggio (lazy AudioContext) */
export const sfx = (src, vol = 0.4) => {
  try {
    const a = new Audio(src);
    a.volume = vol;
    a.play().catch(() => {});
  } catch {}
};

// synthesized board audio — same Web Audio approach as the critter calls, no files
let boardCtx = null;
export const unlockBoardAudio = () => {
  try {
    boardCtx ||= new (window.AudioContext || window.webkitAudioContext)();
    if (boardCtx.state === "suspended") boardCtx.resume().catch(() => {});
  } catch {}
};

// dice-roll clatter — a burst of hard tumbling ticks, then a low felt thock
export const diceClatter = () => {
  try {
    unlockBoardAudio();
    if (!boardCtx || boardCtx.state !== "running") return;
    const t0 = boardCtx.currentTime;
    for (let i = 0; i < 6; i++) {
      const t = t0 + i * (0.04 + Math.random() * 0.035);
      const osc = boardCtx.createOscillator();
      const gain = boardCtx.createGain();
      osc.type = "square";
      osc.frequency.setValueAtTime(1100 + Math.random() * 1300, t);
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.09, t + 0.004);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.045);
      osc.connect(gain).connect(boardCtx.destination);
      osc.start(t);
      osc.stop(t + 0.05);
    }
    const tt = t0 + 0.3;
    const thock = boardCtx.createOscillator();
    const thockGain = boardCtx.createGain();
    thock.type = "sine";
    thock.frequency.setValueAtTime(220, tt);
    thock.frequency.exponentialRampToValueAtTime(70, tt + 0.09);
    thockGain.gain.setValueAtTime(0.0001, tt);
    thockGain.gain.exponentialRampToValueAtTime(0.16, tt + 0.008);
    thockGain.gain.exponentialRampToValueAtTime(0.0001, tt + 0.12);
    thock.connect(thockGain).connect(boardCtx.destination);
    thock.start(tt);
    thock.stop(tt + 0.13);
  } catch {}
};

// winner fanfare — rising major arpeggio when someone takes the crown
export const winnerFanfare = () => {
  try {
    unlockBoardAudio();
    if (!boardCtx || boardCtx.state !== "running") return;
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => {
      const t = boardCtx.currentTime + i * 0.09;
      const osc = boardCtx.createOscillator();
      const gain = boardCtx.createGain();
      osc.type = "triangle";
      osc.frequency.setValueAtTime(f, t);
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.12, t + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.34);
      osc.connect(gain).connect(boardCtx.destination);
      osc.start(t);
      osc.stop(t + 0.36);
    });
  } catch {}
};
